import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfig } from '../../../core/services/app-config.service';
import { HandsetService } from '../../../core/services/handset.service';

@Component({
  selector: 'app-fab',
  styleUrls: ['./fab.component.scss'],
  templateUrl: './fab.component.html',
  standalone: true,
})
export class FabComponent {
  @Input() public icon: string;
  @Input() public text: string;
  @Input() public tooltip: string;
  @Output() public clicked = new EventEmitter();

  public hasChat: boolean;

  constructor(private appConfig: AppConfig, public handsetService: HandsetService) {
    this.hasChat = this.appConfig.config.analytics.intercom.enabled || this.appConfig.config.analytics.crisp.enabled;
    this.handsetService.handsetChanges.subscribe((isHandset) => {
      this.hasChat = !isHandset;
    });
  }
}
